import { propHasValue } from "../../components/DynamicFormNew/helper";
import initialState from "../models/paginated";

export const types = {
  FETCH_PAGINATED_REQUESTED: "FETCH_PAGINATED_REQUESTED",
  FETCH_PAGINATED_SUCCEDDED: "FETCH_PAGINATED_SUCCEDDED",
  FETCH_PAGINATED_FAILED: "FETCH_PAGINATED_FAILED"
};

const reducer = (state = initialState, action) => {
  const entity = action.value ? action.value.entity : "";
  const entityState = entity ? state[entity] : {};
  let newState = {};

  switch (action.type) {
    case types.FETCH_PAGINATED_REQUESTED:
      newState = {
        ...entityState,
        loading: true,
        page: entityState.page + 1,
        calling: true
      };
      break;

    case types.FETCH_PAGINATED_SUCCEDDED:
      newState = {
        ...entityState,
        [entity]: [...entityState[entity], ...action.value.paginated],
        loading:
          propHasValue(action.value.done)
            ? !action.value.done
            : action.value.paginated.length === 10,
        calling: false
      };
      break;

    case types.FETCH_PAGINATED_FAILED:
      newState = {
        ...entityState,
        page: entityState.page - 1,
        done: true,
        error: true,
        calling: false
      };
      break;

    default:
      newState = entityState;
      break;
  }

  return entity ? { ...state, [entity]: newState } : state;
};

export default reducer;
